var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHoroscope(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2485_2957)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.2979 9.71042C36.4588 9.78815 36.6184 9.86788 36.7768 9.94962",
    stroke: "#862B89",
    strokeWidth: 0.848431,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6719 11.0655C44.1133 14.6861 47.7058 20.9182 47.7058 27.9999C47.7058 34.5503 44.6322 40.3738 39.8641 44.076",
    stroke: "#862B89",
    strokeWidth: 0.848431,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1.1 2.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9777 44.7268C38.8317 44.8284 38.6835 44.9281 38.5332 45.0257",
    stroke: "#862B89",
    strokeWidth: 0.848431,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6122 47.8652C31.4376 47.9004 31.2622 47.9333 31.0859 47.964",
    stroke: "#862B89",
    strokeWidth: 0.848431,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.919 48.2172C28.5105 48.2423 28.0987 48.2549 27.6838 48.2549C16.6269 48.2549 7.66113 39.1863 7.66113 27.9996C7.66113 16.8129 16.6269 7.74454 27.6838 7.74454C28.7343 7.74392 29.7831 7.82628 30.8206 7.99086",
    stroke: "#862B89",
    strokeWidth: 0.848431,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1.09 2.18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8926 8.19312C32.0674 8.23088 32.2413 8.27102 32.4142 8.31354",
    stroke: "#862B89",
    strokeWidth: 0.848431,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.53613 10.598C6.64816 10.459 6.76138 10.321 6.87578 10.1842",
    stroke: "#862B89",
    strokeWidth: 0.848431,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.27148 8.64059C13.2156 3.56807 20.0868 0.424225 27.6836 0.424225C36.1679 0.424225 43.749 4.34589 48.7471 10.4959",
    stroke: "#862B89",
    strokeWidth: 0.848431,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1.04 2.08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3877 11.3153C49.495 11.4578 49.6009 11.6015 49.7054 11.7464",
    stroke: "#862B89",
    strokeWidth: 0.848431,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.58398 47.6744C8.71061 47.8003 8.83833 47.9249 8.96715 48.048",
    stroke: "#862B89",
    strokeWidth: 0.848431,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5508 49.4482C15.2325 53.2798 21.1939 55.5755 27.6836 55.5755C36.3921 55.5755 44.1467 51.4445 49.1363 45.0142",
    stroke: "#862B89",
    strokeWidth: 0.848431,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1.06 2.11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7676 44.1671C49.8714 44.0221 49.9739 43.8761 50.0752 43.7292",
    stroke: "#862B89",
    strokeWidth: 0.848431,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.85031 16.6145C2.77733 16.7772 2.70581 16.9408 2.63574 17.1052",
    stroke: "#862B89",
    strokeWidth: 0.848431,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.90012 19.0276C0.919159 21.9171 0.420405 24.9484 0.423846 27.9999C0.423846 33.0609 1.7723 37.8036 4.12437 41.8805",
    stroke: "#862B89",
    strokeWidth: 0.848431,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1.03 2.06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.65527 42.762C4.75015 42.9133 4.84649 43.0635 4.94429 43.2128",
    stroke: "#862B89",
    strokeWidth: 0.848431,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7412 17.1301C52.8109 17.2943 52.8791 17.4593 52.9459 17.6249",
    stroke: "#862B89",
    strokeWidth: 0.848431,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6839 19.6902C55.5441 25.6798 55.3394 32.1205 53.1025 37.9799",
    stroke: "#862B89",
    strokeWidth: 0.848431,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1.1 2.19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6875 38.995C52.6169 39.1592 52.5446 39.3224 52.4707 39.4846",
    stroke: "#862B89",
    strokeWidth: 0.848431,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6829 37.092C32.6467 37.092 36.6706 33.0213 36.6706 27.9999C36.6706 22.9784 32.6467 18.9077 27.6829 18.9077C22.7192 18.9077 18.6953 22.9784 18.6953 27.9999C18.6953 33.0213 22.7192 37.092 27.6829 37.092Z",
    stroke: "#862B89",
    strokeWidth: 0.848431,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6253 12.5445L25.2139 16.7696H30.0368L27.6253 12.5445Z",
    stroke: "#862B89",
    strokeWidth: 0.848431,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6253 43.4555L25.2139 39.2303H30.0368L27.6253 43.4555Z",
    stroke: "#862B89",
    strokeWidth: 0.848431,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9033 27.9999L38.7266 25.5605V30.4393L42.9033 27.9999Z",
    stroke: "#862B89",
    strokeWidth: 0.848431,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3467 27.9999L16.5234 25.5605V30.4393L12.3467 27.9999Z",
    stroke: "#862B89",
    strokeWidth: 0.848431,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.314 16.956L33.6689 18.2686L37.1149 21.6818L38.314 16.956Z",
    stroke: "#862B89",
    strokeWidth: 0.848431,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9365 39.0437L18.1353 34.318L21.5815 37.7311L16.9365 39.0437Z",
    stroke: "#862B89",
    strokeWidth: 0.848431,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5118 38.8434L37.2273 34.1406L33.8438 37.6172L38.5118 38.8434Z",
    stroke: "#862B89",
    strokeWidth: 0.848431,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7383 17.1566L21.4063 18.3828L18.0227 21.8594L16.7383 17.1566Z",
    stroke: "#862B89",
    strokeWidth: 0.848431,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.852 19.4909C29.8401 19.1047 28.766 18.9071 27.6829 18.9077C22.7191 18.9077 18.6953 22.9782 18.6953 27.9999C18.6953 33.0215 22.7185 37.092 27.6829 37.092C28.766 37.0926 29.8401 36.895 30.852 36.5088C30.7827 36.4874 24.0645 34.3981 24.0645 28.0546C24.0645 21.7111 30.7844 19.5128 30.852 19.4909Z",
    stroke: "#862B89",
    strokeWidth: 0.848431,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.57214 17.0734C6.50615 17.0734 8.07397 15.4875 8.07397 13.5311C8.07397 11.5747 6.50615 9.98877 4.57214 9.98877C2.63814 9.98877 1.07031 11.5747 1.07031 13.5311C1.07031 15.4875 2.63814 17.0734 4.57214 17.0734Z",
    stroke: "#862B89",
    strokeWidth: 0.848431,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2202 11.5236C35.3806 11.5236 36.3213 10.572 36.3213 9.39813C36.3213 8.22427 35.3806 7.27267 34.2202 7.27267C33.0598 7.27267 32.1191 8.22427 32.1191 9.39813C32.1191 10.572 33.0598 11.5236 34.2202 11.5236Z",
    stroke: "#862B89",
    strokeWidth: 0.848431,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.037 50.1354C37.1 50.1354 38.7723 48.4437 38.7723 46.3569C38.7723 44.2701 37.1 42.5784 35.037 42.5784C32.9741 42.5784 31.3018 44.2701 31.3018 46.3569C31.3018 48.4437 32.9741 50.1354 35.037 50.1354Z",
    stroke: "#862B89",
    strokeWidth: 0.848431,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.853 17.7818C52.5613 17.7818 53.9462 16.3808 53.9462 14.6527C53.9462 12.9246 52.5613 11.5236 50.853 11.5236C49.1446 11.5236 47.7598 12.9246 47.7598 14.6527C47.7598 16.3808 49.1446 17.7818 50.853 17.7818Z",
    stroke: "#862B89",
    strokeWidth: 0.848431,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.73085 48.3641C8.31026 48.3641 9.59061 47.0689 9.59061 45.4712C9.59061 43.8736 8.31026 42.5784 6.73085 42.5784C5.15145 42.5784 3.87109 43.8736 3.87109 45.4712C3.87109 47.0689 5.15145 48.3641 6.73085 48.3641Z",
    stroke: "#862B89",
    strokeWidth: 0.848431,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9111 43.8773C52.2648 43.8773 53.3622 42.7671 53.3622 41.3977C53.3622 40.0282 52.2648 38.9181 50.9111 38.9181C49.5574 38.9181 48.46 40.0282 48.46 41.3977C48.46 42.7671 49.5574 43.8773 50.9111 43.8773Z",
    stroke: "#862B89",
    strokeWidth: 0.848431,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2485_2957"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55.367,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoroscope);
export default __webpack_public_path__ + "static/media/horoscope.8d0877b2f73021db36e604c2d5974961.svg";
export { ForwardRef as ReactComponent };